module.exports = __webpack_public_path__ + "img/logo-um-fzv.9a970549.png";